var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { GridLayout } from 'json-to-grid-layout';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { filter } from 'rxjs/operators';
import WindowConfigContext from '../../context/window-config-context';
import { clickButtonObj, showPointerOnButton } from '../../helpers/dom-utils';
import atmosphLayerAndAntiairwind from './AtmosphLayersAndAntiairwind.json';
import atmosphLayerAndDensity from './AtmosphLayersAndDensity.json';
import atmosphLayerAndSurfacewind from './AtmosphLayersAndSurfacewind.json';
import atmosphLayerAndTemp from './AtmosphLayersAndTemp.json';
import auxiliarLogsJson from './AuxiliarLogs.json';
import auxiliarMaintanence from './AuxiliarMaintenance.json';
import auxiliarVideoJson from './AuxiliarVideo.json';
import correctAndEnter from './CorrectAndEnter.json';
import correctAndLog from './CorrectAndLog.json';
import eoSensorAndAcquiring from './EOSensorsAndAcquiring.json';
import eoSensorAndManualJson from './EOSensorsAndManualControl.json';
import eoSensorPreActionJson from './EOSensorsAndPreAction.json';
import eoWeaponAndFireMode from './EOWeaponAndFireMode.json';
import sensorAndRadar from './SensorAndRadar.json';
import sensorAndAcquiring from './SensorsAndAcquiring.json';
import sensorAndManualJson from './SensorsAndManualControl.json';
import sensorPreActionJson from './SensorsAndPreAction.json';
import shipDataAndKinematicData from './ShipDataAndKinematicData.json';
import shipDataAndPlatformData from './ShipDataAndPlatformData.json';
import { dereferenceOfJson } from './util';
import weaponAndBallisticParams from './WeaponAndBallisticParams.json';
import weaponAndControl from './WeaponAndControl.json';
import weaponAndFireMode from './WeponAndFireMode.json';
var layoutIdToJsonMap = {
    reo_gfcs_sensors_acquiring_tracking: sensorAndAcquiring,
    reo_gfcs_sensors_preaction: sensorPreActionJson,
    reo_gfcs_sensors_manual_control: sensorAndManualJson,
    reo_gfcs_sensors_radar: sensorAndRadar,
    reo_gfcs_weapon_fire_mode: weaponAndFireMode,
    reo_gfcs_weapon_control: weaponAndControl,
    reo_gfcs_weapon_ballastic_params: weaponAndBallisticParams,
    reo_gfcs_correct_enter: correctAndEnter,
    reo_gfcs_correct_log: correctAndLog,
    reo_atmosph_layers_surface_wind: atmosphLayerAndSurfacewind,
    reo_atmosph_layers_antiair_wind: atmosphLayerAndAntiairwind,
    reo_atmosph_layers_temperat: atmosphLayerAndTemp,
    reo_atmosph_layers_density: atmosphLayerAndDensity,
    reo_ship_data_platform_data: shipDataAndPlatformData,
    reo_ship_data_kinematic_data: shipDataAndKinematicData,
    reo_auxiliar_logs: auxiliarLogsJson,
    reo_auxiliar_video: auxiliarVideoJson,
    reo_auxiliar_maintenance: auxiliarMaintanence,
    eo_gfcs_sensors_acquiring_tracking: eoSensorAndAcquiring,
    eo_gfcs_sensors_preaction: eoSensorPreActionJson,
    eo_gfcs_sensors_manual_control: eoSensorAndManualJson,
    eo_gfcs_weapon_fire_mode: eoWeaponAndFireMode,
};
export default function GFCSTouchPanel(_a) {
    var _this = this;
    var layoutId = _a.layoutId, onButtonClick = _a.onButtonClick, onLabelClick = _a.onLabelClick, onTableClick = _a.onTableClick, content = _a.content, actionService = _a.actionService, dispatch = _a.dispatch, textPanel = _a.textPanel;
    var jsonDefinition = layoutIdToJsonMap[layoutId];
    var jsonData = dereferenceOfJson(jsonDefinition, jsonDefinition, {});
    var _b = useState(), bClickAction = _b[0], setBClickAction = _b[1];
    var ref = useRef(null);
    useEffect(function () {
        if (actionService && content.mode === 'demo') {
            var subscription_1 = actionService
                .getActions()
                .pipe(filter(function (action) { return action.type === 'TouchPanelButtonOperation'; }))
                .subscribe(function (action) { return setBClickAction(action); });
            return function () {
                subscription_1.unsubscribe();
            };
        }
        else {
            return function () {
                console.log('Catiz-TouchPanel-No actions subscribed');
            };
        }
    }, []);
    useEffect(function () {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var payload, buttonId, getButton, buttonObj;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!bClickAction) return [3, 6];
                        payload = bClickAction.payload;
                        buttonId = payload.actionPayload.TouchPanelButtonClickedId;
                        getButton = function (id) {
                            return ref.current.querySelector("#" + id);
                        };
                        if (!(buttonId && ref && ref.current)) return [3, 4];
                        buttonObj = getButton(buttonId);
                        if (!buttonObj) return [3, 2];
                        return [4, showPointerOnButton(buttonObj, dispatch)];
                    case 1:
                        _a.sent();
                        clickButtonObj(buttonObj);
                        return [3, 3];
                    case 2:
                        alert("Can't find button: " + buttonId + " for current role");
                        return [2];
                    case 3: return [3, 5];
                    case 4:
                        console.log('Cant click on touchpanel because buttonId:', buttonId, ' ref:', ref);
                        alert("Invalid Operation, something is wrong with the lesson definition, no buttonId provided for TouchPanelButtonOperation");
                        _a.label = 5;
                    case 5:
                        console.log(' I got action', ref, bClickAction);
                        _a.label = 6;
                    case 6: return [2];
                }
            });
        }); })();
    }, [bClickAction]);
    var handleButtonClick = function (id) {
        onButtonClick(id);
    };
    var onIndicatorButtonClick = function (id) {
        if (config.isBuilder) {
            onButtonClick(id);
        }
    };
    var handleTableClick = function (id, columns) {
        if (config.isBuilder) {
            onTableClick(id, columns);
        }
    };
    var handleLabelClick = function (id) {
        if (config.isBuilder) {
            onLabelClick(id);
        }
    };
    var config = useContext(WindowConfigContext) || { isBuilder: false };
    return (React.createElement("div", { "data-layout": layoutId, ref: ref },
        React.createElement(GridLayout, { content: __assign(__assign({}, content), textPanel), jsonData: jsonData, onButtonClick: handleButtonClick, onIndicatorButtonClick: onIndicatorButtonClick, onLabelClick: handleLabelClick, onTableClick: handleTableClick, isBuilder: config.isBuilder })));
}
//# sourceMappingURL=index.js.map